import React, { useState, useEffect, Link } from 'react';
import BitmediaAd from '../../../mission/bitmedia';
import axios from 'axios';
import { alert_error, alert_success } from '../../../../AppContext';
import AdSense from "react-adsense";
const CheckCode = () => {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const [iduser, setiduser] = useState('');
    const [tele_code, settele_code] = useState('');
    function guimacode() {
        const currentUrl = new URL(window.location.href);
        // Lấy giá trị của tham số 'iduser'
        const userId = currentUrl.searchParams.get('iduser');
        setiduser(userId);
        console.log(userId); // Kết quả là '21285'
        axios
            .get('https://hust.media/jop/mission/sendcode.php?iduser=' + userId)
            .then(response => (alert_success('Đã gửi mã code qua tele')))
            .catch(error => console.log(error))
    };
    function handleSubmit(event) {
        setnutxuly(1);
        setnutorder('Please wait a moment 😊');
        if (!iduser) {
            alert('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        axios
            .get('https://hust.media/jop/mission/checkcode.php?tele_code=' + tele_code)
            .then(response => (testFunction(response)))
            .catch(error => console.log(error))

    }
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 700);
        }
    };
    useEffect(() => {
        guimacode();
    }, []);
    return (
        <>
            <div className="max-h-16">
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: "block", height: 50 }}
                        format=""
                    />{" "}
                </div>
            </div>
            <div className='items-center justify-center mt-1'>
                <div className="max-w-4xl mx-auto">
                    <div className="bg-white p-4 rounded shadow-md mb-0 w-full">
                        <div className="text-xl mb-1">Nhập mã xác nhận</div>
                        <input
                            type="text"
                            placeholder="Mã xác nhận"
                            className="border-2 border-pink-400 rounded-md p-3 pl-10 w-full focus:outline-none focus:border-pink-500"
                            value={tele_code}
                            onChange={(e) => settele_code(e.target.value)}
                        />
                        <div className="mt-2 text-lg font-bold mb-2">Kiểm tra telegram của bạn mã được gửi từ bot hust media</div>
                        <div className="flex items-start">
                            <button
                                disabled={nutxuly == 1}
                                onClick={handleSubmit}
                                className='w-4/5 h-12 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 dark:bg-slate-800 dark:text-white'
                            >
                                <div className='flex items-center justify-between flex-1'>
                                    {nutxuly == 1 && (
                                        <div className="spinner-border" role="status"></div>
                                    )}
                                    <span className='text-lg font-medium text-white'>{nutorder}</span>
                                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                </div>
                            </button>

                            <button onClick={guimacode}
                                className="w-1/5 flex break-inside bg-green-500 text-white px-2 rounded-3xl mb-3 ml-2"
                            >
                                <div className='flex items-center justify-between flex-1'>
                                    <span className='text-center text-lg font-medium text-white'>Gửi lại mã</span>
                                </div>
                            </button>
                        </div>

                    </div>
                </div>
                <BitmediaAd />
            </div>

        </>

    );
};

export default CheckCode;
